import endpoint from "../../config/endpoints";

export const grnHistoryJson = {
  showSaveNextBtn: true,
  showAddButton: true,
  apiBaseURL: endpoint.area,
  screenTitle: " GRN History ",
  formPathView: "/grn-history-view",

  tableColumnsToFilter: [
    {
      columnDisplayName: "GRN Number",
      columnKeyName: "grnGvnNo",
      isChecked: true,
    },
    {
      columnDisplayName: "GRN Date",
      columnKeyName: "date",
      isChecked: true,
    },
    {
      columnDisplayName: "Firm Name",
      columnKeyName: "fromStockStakeHolderOwnerName",
      isChecked: true,
    },
    {
      columnDisplayName: "State Name",
      columnKeyName: "fromStockStakeHolderStateName",
      isChecked: true,
    },
    {
      columnDisplayName: "Area Name",
      columnKeyName: "fromStockStakeHolderAreaNames",
      isChecked: true,
    },
    {
      columnDisplayName: "Taxable Amount",
      columnKeyName: "taxableAmt",
      isChecked: true,
    },
    {
      columnDisplayName: "Total Amount",
      columnKeyName: "totalAmt",
      isChecked: true,
    },
  ],

  searchList: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromdate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "todate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "todate",
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromdate-ge",
    },
  ],
};
